import C from '../actionTypes';

export const authData = (state = {}, action) => {
    switch (action.type) {
        case C.USER_LOGIN:
            return action.authData;
        case C.LOGIN_REQUEST:
            return {loading: true, ...action.authData};
        case C.LOGIN_SUCCESS:
            return {loading: false, ...action.authData};
        case C.LOGIN_FAILURE:
            return {loading: false, ...action.authData};
        case C.USER_LOGOUT:
            return {};
        case C.PASSWORD_RECOVERY_SUCCESS:
            return action.authData;
        case C.PASSWORD_RECOVERY_FAILURE:
            return action.authData;
        case C.ADD_ACCOUNTS_DATA:
            let newState = {...state};
            newState.accounts = [...state.accounts, ...action.newAccountsData];
            return newState;
        // case C.DISBAND_CLUB_SUCCESS:
        //     const accounts = state.accounts.filter(acc => acc.id != action.clubId && acc.clubId != action.clubId);
        //     console.log('accounts: ', accounts);
        //     return {...state, accounts};
        default :
            return state
    }
};

export const globalAccount = (state = {}, action) => {
    switch (action.type) {
        case C.GLOBALACCOUNT_SUCCESS:
            return action.globalAccountIn;
        case C.GLOBALACCOUNT_FAILURE:
            return action.globalAccountIn;
        case C.GLOBAL_AVATAR_SUCCESS:
            return {...state, avatarId: action.avatarId};
        case C.GLOBAL_AVATAR_FAILURE:
            return {...state, avatarId: action.avatarId};
        case C.CHANGE_PROFILE_AVATAR:
            return {...state, avatarId: action.avatarId};
        case C.USER_LOGOUT:
            return {};
        default :
            return state
    }
};

export const globalBalance = (state = {}, action) => {
    switch (action.type) {
        case C.GLOBALACCOUNT_SUCCESS:
            return {
                money: action.globalAccountIn.money,
                moneyName: action.globalAccountIn.wallets[0].name,
                diamonds: action.globalAccountIn.diamonds,
                diamondsName: action.globalAccountIn.wallets[1].name
            };
        case C.GLOBALACCOUNT_FAILURE:
            return {money: {balance: 0}, diamonds: {balance: 0}};
        case C.GLOBAL_UPDATE_SUCCESS:
            return {
                money: action.globalAccountIn.wallets[0].balance,
                moneyName: action.globalAccountIn.wallets[0].name,
                diamonds: action.globalAccountIn.wallets[1].balance,
                diamondsName: action.globalAccountIn.wallets[1].name
            };
        case C.GLOBAL_UPDATE_FAILURE:
            return state;
        case C.USER_LOGOUT:
            return {};
        default :
            return state
    }
};

export const verificationCode = (state = {verificationCode: '', verified: false}, action) => {
  switch (action.type) {
      case C.LINK_EMAIL_VERIFICATION_SUCCESS:
          return {...state, verificationCode: `${action.value}`};
      case C.LINK_EMAIL_VERIFICATION_CODE_SUCCESS:
          console.log('actionactionaction: ', action)
          return {...state, verified: true};
      case C.LINK_EMAIL_VERIFICATION_FAILURE:
          return state;
      default :
          return state
  }
}
